import {
  LOCAL_STORAGE_KEYS,
  LocalStorageInstance,
} from 'src/lib/local-storage';
import { RestAPI } from 'src/lib/rest-api';
import { create } from 'zustand';
interface AdminStore {
  adminAuthToken: string | null;

  removeAdminAuthToken: () => void;
  setAdminAuthToken: (token: string) => void;
}

export const AdminRestAPIInstance = new RestAPI();
AdminRestAPIInstance.httpClient.interceptors.request.use((config) => {
  if (config.headers) {
    const token = LocalStorageInstance.getItem(
      LOCAL_STORAGE_KEYS.ADMIN_AUTH_TOKEN_JWT,
    );
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});
export const useAdminStore = create<AdminStore>((set) => ({
  adminAuthToken: null,
  isAdmin: false,
  isAdminAuthorized: null,
  removeAdminAuthToken: () => {
    LocalStorageInstance.removeItem(LOCAL_STORAGE_KEYS.ADMIN_AUTH_TOKEN_JWT);
    set({ adminAuthToken: null });
  },
  setAdminAuthToken: (token: string) => {
    LocalStorageInstance.setItem(
      LOCAL_STORAGE_KEYS.ADMIN_AUTH_TOKEN_JWT,
      token,
    );
    set({ adminAuthToken: token });
  },
}));
